// Shop card hover videos, by offer itemType: a short product turn that replaces
// the hover image swap. The render files from C:\claude\workspace\vrs\thumb\out
// are served exactly as delivered (1080x1080, 3 s, one turn starting and ending
// on the shop angle); the card crops them to its 4:3 image box with
// object-fit: cover, which keeps the whole product (it sits in rows ~276-824):
//   webm: VP9 with alpha, for Chrome, Edge and Firefox (any card background)
//   mp4:  H.264 on the light card grey #F4F4F4, for Safari, which plays VP9
//         WebM but drops its alpha (a black box)
// `thumb` is the static render of the video's first frame, used as the card
// image so the hover turn starts from exactly what the card shows: `light` on
// the plain #F4F4F4 card, `alpha` (transparent) on deal and dark cards.
// Built from a const + template so the URLs are not JSX string literals
// (no-raw-media-src); there is no #67 resolver path for video.
const VIDEOS = '/videos/shop'
const IMAGES = '/images/shop'

export const SHOP_HOVER_VIDEOS = {
  DFP15_WHEEL_BASE: {
    webm: `${VIDEOS}/dfp15_hover_noxray_1080_transparent.webm`,
    mp4: `${VIDEOS}/dfp15_hover_noxray_1080_f4f4f4.mp4`,
    width: 1080,
    height: 1080,
    thumb: {
      light: { src: `${IMAGES}/dfp15_thumb_noxray_1080_f4f4f4.png`, width: 1080, height: 1080, alt: 'DFP15 Wheel Base' },
      alpha: { src: `${IMAGES}/dfp15_thumb_noxray_1080_transparent.png`, width: 1080, height: 1080, alt: 'DFP15 Wheel Base' },
    },
  },
}

export function getShopHoverVideo(itemType) {
  return (itemType && SHOP_HOVER_VIDEOS[itemType]) || null
}
